export default "__VITE_ASSET__BE9TOM3w__"